import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addRow", "addForm", "nameInput", "editModal", "editId", "editInput", "row"]

  get spinnerHtml() {
    return `<svg class="animate-spin w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>`
  }

  showAddForm() {
    this.addRowTarget.classList.add("hidden")
    this.addFormTarget.classList.remove("hidden")
    this.nameInputTarget.focus()
  }

  hideAddForm() {
    this.addFormTarget.classList.add("hidden")
    this.addRowTarget.classList.remove("hidden")
    this.nameInputTarget.value = ""
  }

  async create(event) {
    event.preventDefault()
    const name = this.nameInputTarget.value.trim()
    if (!name) return

    const button = event.target.querySelector("button[type='submit']")
    const originalHtml = button.innerHTML
    button.disabled = true
    button.innerHTML = this.spinnerHtml

    const csrfToken = document.querySelector("meta[name='csrf-token']").content

    try {
      const response = await fetch("/meal_types", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: new URLSearchParams({ "meal_type[name]": name })
      })

      if (response.ok) {
        window.location.reload()
      } else {
        const data = await response.json()
        if (data.error && window.showToast) {
          window.showToast(data.error)
        }
        button.disabled = false
        button.innerHTML = originalHtml
      }
    } catch {
      button.disabled = false
      button.innerHTML = originalHtml
    }
  }

  edit(event) {
    const { mealTypeId, mealTypeName } = event.currentTarget.dataset
    this.editIdTarget.value = mealTypeId
    this.editInputTarget.value = mealTypeName
    this.editModalTarget.classList.remove("hidden")
    this.editInputTarget.focus()
    this.editInputTarget.select()
  }

  closeEdit() {
    this.editModalTarget.classList.add("hidden")
    this.editIdTarget.value = ""
    this.editInputTarget.value = ""
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  async update(event) {
    event.preventDefault()
    const id = this.editIdTarget.value
    const name = this.editInputTarget.value.trim()
    if (!name) return

    const button = event.target.querySelector("button[type='submit']")
    const originalHtml = button.innerHTML
    button.disabled = true
    button.innerHTML = this.spinnerHtml

    const csrfToken = document.querySelector("meta[name='csrf-token']").content

    try {
      const response = await fetch(`/meal_types/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: new URLSearchParams({ "meal_type[name]": name })
      })

      if (response.ok) {
        window.location.reload()
      } else {
        const data = await response.json()
        if (data.error && window.showToast) {
          window.showToast(data.error)
        }
        button.disabled = false
        button.innerHTML = originalHtml
      }
    } catch {
      button.disabled = false
      button.innerHTML = originalHtml
    }
  }

  async delete(event) {
    const { mealTypeId } = event.currentTarget.dataset
    if (!confirm("¿Eliminar este tipo de comida?")) return

    const button = event.currentTarget
    const originalHtml = button.innerHTML
    button.disabled = true
    button.innerHTML = this.spinnerHtml

    const csrfToken = document.querySelector("meta[name='csrf-token']").content

    try {
      const response = await fetch(`/meal_types/${mealTypeId}`, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        }
      })

      if (response.ok) {
        window.location.reload()
      } else {
        const data = await response.json()
        if (data.error && window.showToast) {
          window.showToast(data.error)
        }
        button.disabled = false
        button.innerHTML = originalHtml
      }
    } catch {
      button.disabled = false
      button.innerHTML = originalHtml
    }
  }
}
